import type { SectionLocale } from '../types'

export const FEEDBACK_LOCALE: SectionLocale = [
  [
    'feedback_delete_email_question',
    {
      ru: 'Удалить почту?',
      en: 'Delete the email?',
    },
  ],
  [
    'feedback_delete_type_question',
    {
      ru: 'Удалить тип?',
      en: 'Delete the type?',
    },
  ],
  [
    'feedback_control_save_success',
    {
      ru: 'Настройки успешно сохранены.',
      en: 'Settings saved successfully.',
    },
  ],
  [
    'feedback_control_load_error',
    {
      ru: 'Не удалось загрузить данные. Попробуйте обновить страницу.',
      en: 'Could not load data. Please try refreshing the page.',
    },
  ],
  [
    'feedback_control_save_error',
    {
      ru: 'Не удалось сохранить изменения. Попробуйте ещё раз.',
      en: 'Could not save changes. Please try again.',
    },
  ],
  [
    'feedback_notification_success',
    {
      ru: 'Ваше обращение отправлено. На указанный email придет ответ. Обычно это занимает 2 рабочих дня',
      en: 'Your request has been sent. A reply will be sent to the email you provided. This usually takes 2 business days.',
    },
  ],
  [
    'feedback_select_type',
    {
      ru: 'Выбрать тип обращения',
      en: 'Select the type of appeal',
    },
  ],
  [
    'feedback_label_type',
    {
      ru: 'Тип обращения',
      en: 'Type of appeal',
    },
  ],
  [
    'feedback_label_email',
    {
      ru: 'Электронная почта для обратной связи',
      en: 'Email for feedback',
    },
  ],
  [
    'feedback_cancel_message',
    {
      ru: 'Вы действительно хотите отменить все изменения?',
      en: 'Are you sure you want to discard all changes?',
    },
  ],
  [
    'feedback_send_error',
    {
      ru: 'Что-то пошло не так, и сообщение не отправлено. Попробуйте еще раз.',
      en: 'Something went wrong and your message was not sent. Please try again.',
    },
  ],
  [
    'feedback_edit_subject',
    {
      ru: 'Тема обращения',
      en: 'Subject of the appeal',
    },
  ],
  [
    'feedback_edit_email',
    {
      ru: 'Ваш Email',
      en: 'Your Email',
    },
  ],
  [
    'feedback_edit_message',
    {
      ru: 'Текст обращения',
      en: 'Text of the appeal',
    },
  ],
  [
    'feedback_emails_list_title',
    {
      ru: 'Адреса электронной почты',
      en: 'Email addresses',
    },
  ],
  [
    'feedback_emails_list_subtitle',
    {
      ru: 'На указанные адреса будут приходить сообщения от пользователей',
      en: 'Messages from users will be sent to the specified addresses',
    },
  ],
  [
    'feedback_types_title',
    {
      ru: 'Типы обращений',
      en: 'Request types',
    },
  ],
  [
    'feedback_types_list_subtitle',
    {
      ru: 'Пользователи смогут выбирать определённый тип обращения для своей обратной связи',
      en: 'Users will be able to select a specific request type for their feedback',
    },
  ],
  [
    'feedback_add_email',
    {
      ru: 'Добавить email',
      en: 'Add email',
    },
  ],
  [
    'feedback_add_type',
    {
      ru: 'Добавить тип обращения',
      en: 'Add request type',
    },
  ],
  [
    'feedback_delete_item',
    {
      ru: 'Удалить',
      en: 'Delete',
    },
  ],
  [
    'feedback_control_edit',
    {
      ru: 'Редактировать',
      en: 'Edit',
    },
  ],
  [
    'feedback_control_row_menu_aria',
    {
      ru: 'Действия со строкой',
      en: 'Row actions',
    },
  ],
  [
    'feedback_control_modal_add_category_title',
    {
      ru: 'Добавить тип обращения',
      en: 'Add request type',
    },
  ],
  [
    'feedback_control_modal_edit_category_title',
    {
      ru: 'Редактировать тип обращения',
      en: 'Edit request type',
    },
  ],
  [
    'feedback_control_modal_add_email_title',
    {
      ru: 'Добавить почту',
      en: 'Add email',
    },
  ],
  [
    'feedback_control_modal_edit_email_title',
    {
      ru: 'Редактировать почту',
      en: 'Edit email',
    },
  ],
  [
    'feedback_control_modal_category_label',
    {
      ru: 'Название',
      en: 'Name',
    },
  ],
  [
    'feedback_control_modal_email_label',
    {
      ru: 'Email',
      en: 'Email',
    },
  ],
  [
    'feedback_control_modal_category_placeholder',
    {
      ru: 'Укажите тип обращения',
      en: 'Enter request type',
    },
  ],
  [
    'feedback_control_modal_email_placeholder',
    {
      ru: "example{'@'}company.com",
      en: "example{'@'}company.com",
    },
  ],
]
